export enum FontFamilyType
{
    Arial = 'Arial',
    ArialBlack = 'Arial Black',
    Bahnschrift = 'Bahnschrift',
    Calibri = 'Calibri',
    Cambria = 'Cambria',
    CambriaMath = 'Cambria Math',
    Candara = 'Candara',
    ComicSansMS = 'Comic Sans MS',
    Consolas = 'Consolas',
    Constantia = 'Constantia',
    Corbel = 'Corbel',
    CourierNew = 'Courier New',
    Ebrima = 'Ebrima',
    FranklinGothicMedium = 'Franklin Gothic Medium',
    Gabriola = 'Gabriola',
    Gadugi = 'Gadugi',
    Georgia = 'Georgia',
    HoloLensMDL2Assets = 'HoloLens MDL2 Assets',
    Impact = 'Impact',
    InkFree = 'Ink Free',
    JavaneseText = 'Javanese Text',
    LeelawadeeUI = 'Leelawadee UI',
    LucidaConsole = 'Lucida Console',
    LucidaSansUnicode = 'Lucida Sans Unicode',
    MalgunGothic = 'Malgun Gothic',
    Marlett = 'Marlett',
    MicrosoftHimalaya = 'Microsoft Himalaya',
    MicrosoftJhengHei = 'Microsoft JhengHei',
    MicrosoftNewTaiLue = 'Microsoft New Tai Lue',
    MicrosoftPhagsPa = 'Microsoft PhagsPa',
    MicrosoftSansSerif = 'Microsoft Sans Serif',
    MicrosoftTaiLe = 'Microsoft Tai Le',
    MicrosoftYaHei = 'Microsoft YaHei',
    MicrosoftYiBaiti = 'Microsoft Yi Baiti',
    MingLiUExtB = 'MingLiU-ExtB',
    MongolianBaiti = 'Mongolian Baiti',
    MSGothic = 'MS Gothic',
    MVBoli = 'MV Boli',
    MyanmarText = 'Myanmar Text',
    NirmalaUI = 'Nirmala UI',
    PalatinoLinotype = 'Palatino Linotype',
    SegoeMDL2Assets = 'Segoe MDL2 Assets',
    SegoePrint = 'Segoe Print',
    SegoeScript = 'Segoe Script',
    SegoeUI = 'Segoe UI',
    SegoeUIHistoric = 'Segoe UI Historic',
    SegoeUIEmoji = 'Segoe UI Emoji',
    SegoeUISymbol = 'Segoe UI Symbol',
    SimSun = 'SimSun',
    Sitka = 'Sitka',
    Sylfaen = 'Sylfaen',
    Symbol = 'Symbol',
    Tahoma = 'Tahoma',
    TimesNewRoman = 'Times New Roman',
    TrebuchetMS = 'Trebuchet MS',
    Verdana = 'Verdana',
    Webdings = 'Webdings',
    Wingdings = 'Wingdings',
    YuGothic = 'Yu Gothic',
    Vivaldi = 'Vivaldi',
}